The input parameter for the `updatePositionOpeningPersonContacts` mutation.
